<template>
  <div class="search_main">
    <div class="search_wrap">
      <div class="logoTitle">
        <img class="logo" src="@/assets/images/footballAssociation.png" alt />
        <img class="title" src="@/assets/images/title_search.png" alt />
      </div>
      <div class="main_content">
        <div class="content btn-group">
          <div class="btn-item" @click="jumpTo('/search_eleven')">
            <!--<v-icon name="users" class="icon" scale="2.4"></v-icon>-->
            <img :src="shiyi" class="icon-img" alt="">
            <span class="text">十一人制足球</span>
          </div>
          <div class="btn-item" @click="jumpTo('/search_five')">
            <!--<v-icon name="user" class="icon" scale="2.4"></v-icon>-->
            <img :src="five" class="icon-img" alt="">
            <span class="text">五人制足球</span>
          </div>
        </div>
      </div>
    </div>
    <app-footer class="footer"></app-footer>
  </div>
</template>

<script>
import "vue-awesome/icons/download";
import "vue-awesome/icons/user";
import "vue-awesome/icons/users";
import shiyi from '@/assets/images/common/shiyi.png'
import five from '@/assets/images/common/five.png'
export default {
  name: "Search",
  components: {
    "app-footer": () => import("@/components/LayOut/Common/Footer"),
    "v-icon": () => import("vue-awesome/components/Icon"),
  },
  data() {
    return {
      showDialog: false,
      formData: {
        id_number: "",
        the_query_code: "",
      },
      isMobile: false,
      shiyi,five
    };
  },
  methods: {
    jumpTo(path) {
      this.$router.push({
        path: path,
      })
    }
  },
  // 首页变灰，剩下页面不变
  mounted() {
    // document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'grayscale(100%)';
  },

  destroyed() {
    // document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'none';
  }
};
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
.search_main
  height 100%
  .search_wrap
    height calc(100% - 60px)
    .logoTitle
      display flex
      justify-content center
      align-items center
      margin 0 0 50px 0
      padding-top 95px
      .logo
        width 120px
        height 120px
        margin 0 15px 0 0
    .main_content
      display flex
      justify-content center
      .content
        width 900px
        height 565px
        padding 0 40px
        &.btn-group
          display flex
          align-items center
          justify-content space-between
          .btn-item
            background-color $block_bg_color_base
            width calc(50% - 60px)
            height 300px
            color #fff
            display flex
            flex-direction column
            align-items center
            justify-content center
            cursor pointer
            user-select none
            .icon
              margin-bottom: 20px
            .text
              font-size 1.8em
  
  
  .icon-img
    width 60px
    height: 60px
    margin-bottom: 15px;
    border-radius: 20%;
    border: 2px solid white;
</style>
